/* unplugin-vue-components disabled */export default {
  name: 'i-copyright',
  data: function data() {
    return {
      copyright: 'Copyright © 2025-2026 浙江深辰凯动科技有限公司 版权所有 浙ICP备2025180714号-1'
    };
  }
};